import { SidebarPortal } from '@plone/volto/components';
import View from './View';
import Sidebar from './Sidebar';

const InfoboxEdit = (props) => {
  const { data, block, selected, onChangeBlock } = props;

  return (
    <>
      <View {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <Sidebar
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default InfoboxEdit;
